import { mapGetters } from 'vuex';
import accountInfoService from '../../account-info.service.js';
import { errorMessage } from '@/utils/message.js';

export default {
  props: {
    userType: {
      type: Number,
      default: 1
    },
    basicInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      idTypeList: []
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    idstrcard() {
      if(this.basicInfo && this.basicInfo.assignorIdCard) {
        return this.basicInfo.assignorIdCard.replace(/(\d{3})\d+(\d{1})/, '$1**************$2');
      }
    },
    idstrcardPer() {
      if(this.basicInfo && this.basicInfo.idCard) {
        return this.basicInfo.idCard.replace(/(\d{3})\d+(\d{1})/, '$1**************$2');
      }
    }
  },
  mounted() {
    this.getIdTypeList();
  },
  methods: {
    // 获取字典：证件类型列表
    getIdTypeList() {
      this.$store.dispatch('getSelectDictList', 'ID_TYPE').then(res => {
        if (res.code === '0') {
          this.idTypeList = res.data;
        }
      });
    },
    // 检查用户是否有在途订单
    checkProcessingOrder (type) {
      accountInfoService.checkProcessingOrder().then(({ code }) => {
        if(code === '0') {
          // 法人变更
          if(type === 2) {
            this.getCurrentUserStatus();
          } else {
            this.$router.push('/person-center/account-info/modify-member-info');
          }
        }
      }).catch(error => {
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    // 法人申请 获取当前申请状态
    getCurrentUserStatus () {
      accountInfoService.getCurrentUserStatus().then(({ code, data }) => {
        if (code === '0') {
          // 状态：10审批中 20审批通过 30法人确认通过 90待开始 91拒绝
          // 跳转到审批页面
          if(data.status !== 30 && data.status !== 90) {
            this.$router.push('/person-center/account-info/modify-legal-second');
          } else {
            this.$router.push('/person-center/account-info/modify-legal-first');
          }
        }
      }, error => {
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    }
  }
};
